(() => {
  if (window.equistoreRecentlyViewed) return;
  const key = 'eq-recently-viewed-v1';
  const legacyKey = 'cc-recently-viewed';
  const lifetime = 30 * 24 * 60 * 60 * 1000;
  const productId = Number(document.currentScript?.dataset.productId);
  let ready = false;

  const allowed = () => {
    try {
      return ready && window.Shopify?.customerPrivacy?.preferencesProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  const clear = () => {
    try {
      localStorage.removeItem(key);
      localStorage.removeItem(legacyKey);
    } catch {}
  };
  const read = () => {
    if (!allowed()) return [];
    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (!saved || !Number.isFinite(saved.expires) || saved.expires <= Date.now() ||
          saved.expires > Date.now() + lifetime || !Array.isArray(saved.items)) {
        localStorage.removeItem(key);
        return [];
      }
      return [...new Set(saved.items.filter(id => Number.isSafeInteger(id) && id > 0))].slice(0, 12);
    } catch {
      return [];
    }
  };
  const notify = () => document.dispatchEvent(new CustomEvent('equistore:history-change'));
  const sync = () => {
    ready = Boolean(window.Shopify?.customerPrivacy);
    if (!allowed()) {
      clear();
    } else {
      try {
        localStorage.removeItem(legacyKey);
        const items = read();
        if (Number.isSafeInteger(productId) && productId > 0) {
          localStorage.setItem(key, JSON.stringify({
            items: [productId, ...items.filter(id => id !== productId)].slice(0, 12),
            expires: Date.now() + lifetime
          }));
        }
      } catch {}
    }
    notify();
  };
  window.equistoreRecentlyViewed = { allowed, read };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) notify();
  });
  const start = () => {
    if (window.Shopify?.customerPrivacy) {
      sync();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) sync();
      });
    }
  };
  start();
  window.addEventListener('load', () => { if (!ready) start(); }, { once: true });
})();
